module.exports = __webpack_public_path__ + "static/media/the-tailor-of-panama.a62705be.webp";